import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import { Provider } from 'react-redux';
import { Favorite, Plus } from '../../../../components/ui/Icons';
import Picture from '../../../../components/ui/Picture/Picture';
import { useGetWishlistItemsQuery, useToggleWishlistMutation } from '../../../../redux-modules/service';
import store from '../../../../redux-modules/store';

function ReduxHit({
  hit,
  additionalData,
}: componentTypes.HitProps) {
  const { catalog } = additionalData;
  const {
    id,
    siteId,
    title,
    uri,
    image,
    onPromotion,
    price,
    promotionalPrice,
    color,
    colorCount,
    productBrand,
  } = hit;

  const { data: wishlistItems } = useGetWishlistItemsQuery({});
  const [handleWishlistToggle, { isSuccess, data }] = useToggleWishlistMutation();

  const isInWishlist = wishlistItems
    && wishlistItems.length > 0
    && wishlistItems.includes(id);

  if (isSuccess) {
    // @ts-ignore
    let successMessage = null;
    if (data.items[0].action === 'added') {
      successMessage = Craft.t(catalog, '{title} is toegevoegd aan je favorieten', {
        title,
      });
    } else {
      successMessage = Craft.t(catalog, '{title} is verwijderd van je favorieten', {
        title,
      });
    }
    const successMessageInput = document.getElementById('notification-success');
    successMessageInput?.setAttribute('value', successMessage);
    htmx.trigger('#notification', 'refresh');
  }

  return (
    <div>
      <a
        href={Craft.getSiteUrl(uri, {
          kleur: color,
        })}
        className="group block no-underline bg-white text-near-black p-4 lg:p-6 rounded-lg hover:shadow-sm h-100"
      >
        <div className="relative pt-[83%] lg:pt-[79%]">
          <button
            type="submit"
            aria-label="favorite"
            className="flex justify-center items-center w-9 h-9 text-near-black hover:text-accent absolute -top-1 right-0 lg:-right-1 transition-all lg:opacity-0 lg:invisible lg:group-hover:opacity-100 lg:group-hover:visible z-20"
            onClick={(event) => {
              event.preventDefault();
              const body = new FormData();
              if (additionalData.csrfTokenName && additionalData.csrfTokenValue) {
                body.append(additionalData.csrfTokenName, additionalData.csrfTokenValue);
              }
              body.append('elementId', id);
              body.append('siteId', siteId);
              body.append('listType', additionalData.wishlistType);
              handleWishlistToggle(body);
            }}
          >
            <Favorite inList={data !== undefined ? (data.items[0].action === 'added') : isInWishlist} />
          </button>
          {(colorCount > 1 || onPromotion) && (
            <div className="absolute top-0 left-0 flex items-center min-h-6 lg:min-h-7 gap-x-3 text-xs lg:text-sm max-w-[80%] z-20">
              {onPromotion && (
                <span className="inline-flex items-center min-h-6 lg:min-h-7 text-xs lg:text-sm text-white bg-accent leading-none font-semibold uppercase px-2 rounded">{Craft.t(catalog, 'Sale')}</span>
              )}
              {colorCount > 1 && (
                <div className="flex items-center gap-1">
                  <Plus className="w-3.5 inline-block" />
                  <span>{colorCount}</span>
                  <span className="inline-lock transition-all lg:opacity-0 lg:invisible lg:group-hover:opacity-100 lg:group-hover:visible flex-1.0">
                    {Craft.t(catalog, 'Variaties beschikbaar')}
                  </span>
                </div>
              )}
            </div>
          )}
          {image && (
            <Picture
              image={image}
              classes="w-full h-full object-contain absolute top-0 left-0"
              loading="lazy"
            />
          )}
        </div>
        {(productBrand || onPromotion) && (
          <div className={`flex gap-x-4 lg:gap-x-6 h-6 ${productBrand ? 'justify-between' : 'justify-end'}`}>
            {productBrand && (
              <h3 className="text-xs lg:text-sm uppercase tracking-widest leading-normal">{productBrand}</h3>
            )}
            {onPromotion && (
              <span className="text-sm lg:text-base leading-normal text-light-grey-2 self-end">
                <s>{price}</s>
              </span>
            )}
          </div>
        )}
        <div className={`flex justify-between gap-x-4 lg:gap-x-6 lg:mb-1 lg:last:mb-0 ${productBrand === undefined && !onPromotion ? 'mt-6' : ''}`}>
          <h3 className="text-base lg:text-xl font-semibold leading-normal truncate">{title}</h3>
          <span className="text-lg lg:text-xl leading-normal font-semibold">{onPromotion ? promotionalPrice : price}</span>
        </div>
      </a>
    </div>
  );
}

export default function Hit({
  results,
  hit,
  additionalData,
}: componentTypes.HitProps) {
  return (
    <Provider store={store}>
      <ReduxHit
        results={results}
        hit={hit}
        additionalData={additionalData}
      />
    </Provider>
  );
}
